import React, { type FC, type PropsWithChildren } from 'react'
import { Stack, type SxProps, type Theme } from '@mui/material'

import { LinearProgressLoader } from '../LinearProgress'
import { TopNavigation } from './TopNavigation'

const wrapperStyle: SxProps<Theme> = { height: '100vh' }
const contentWrapperStyle: SxProps<Theme> = { height: '100%', overflowY: 'hidden' }

export const AppNavigation: FC<PropsWithChildren> = ({ children }) => (
    <Stack sx={wrapperStyle}>
        <TopNavigation />
        <LinearProgressLoader />
        <Stack flexGrow={1} sx={contentWrapperStyle} direction="row">
            {children}
        </Stack>
    </Stack>
)
